<template>
  <div class="context">
    <p class="title">提供データ</p>
    <p class="item subtitle">データ一覧</p>
    <p class="item">
      データカタログサイトに掲載されている情報の一部を定期的に同期し、本APIにて取得できるようにしています。<br />
      具体的には以下の情報をAPI経由で提供しています。<br />
      各データにどのような情報が含まれているかなどの詳細につきましては、データソースであるデータカタログサイトをご確認ください。<br />
      "データ詳細"列に各データの詳細を確認できるリンクがございます。
    </p>
    <p class="errorMsg" v-if="errorFlag">
      読み込みに失敗しました。<br />
      時間を置いて再度ご確認ください。
    </p>
    <div class="fillterSpase" v-if="this.selected_data.length != 0">
      <v-card class="card">
        <div class="cardTitle" @click="this.show = !this.show">
          <v-icon icon="mdi-filter-outline" class="filterIcon"></v-icon>
          <p class="filterTitle">絞り込み</p>
          <v-icon
            icon="mdi-chevron-down"
            class="arrowIcon"
            v-show="!this.show"
          ></v-icon>
          <v-icon
            icon="mdi-chevron-up"
            class="arrowIcon"
            v-show="this.show"
          ></v-icon>
        </div>
        <v-expand-transition class="expand">
          <div v-show="show">
            <v-divider></v-divider>
            <div class="fillter">
              <v-select
                v-model="selectedCategory"
                :items="largeCategory"
                Chips
                label="大分類"
                persistent-hint
                variant="underlined"
              ></v-select>
              <v-select
                v-model="selectedSmc"
                :items="smc"
                Chips
                label="中小分類"
                persistent-hint
                variant="underlined"
                v-bind:disabled="categorySelected"
              ></v-select>
              <v-btn @click="search()">検索</v-btn>
              <v-btn @click="clear()">クリア</v-btn>
            </div>
          </div>
        </v-expand-transition>
      </v-card>
    </div>
    <div class="table">
      <loading
        :active="true"
        :is-full-page="false"
        :height="50"
        :opacity="0"
        v-if="this.selected_data.length == 0"
      />
      <div class="nowLoading" v-if="this.selected_data.length == 0">
        <p>Now Loading...</p>
      </div>
      <div v-if="this.selected_data.length != 0">
        <p class="dataCounter">
          API利用可能なデータ: <span>{{ items }}</span> 件
        </p>
        <p class="updateTime">データ更新日時:{{ lastUpdate }}</p>
        <div class="tableWrap">
          <table class="dataTable">
            <tr>
              <th>大分類</th>
              <th>中小分類</th>
              <th>データ名</th>
              <th>データ番号</th>
              <th>基準日</th>
              <th>データ詳細</th>
            </tr>
            <tr v-for="item in selected_data" :key="item.resourceId">
              <td>
                {{ item.largeCategory }}
              </td>
              <td>{{ item.smc }}</td>
              <td>
                {{ item.packageName }}
              </td>
              <td>
                {{ item.entityType }}
              </td>
              <td>
                {{ item.dataAcquisitionDate }}
              </td>
              <td class="text-center">
                <a
                  :href="item.ckanUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><v-icon icon="mdi-link"></v-icon
                ></a>
              </td>
            </tr>
          </table>
        </div>
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </div>
    </div>
    <div class="table">
      <p class="item subtitle">取得できるデータの種類</p>
      <p class="item">
        上記に記載しているデータは2種類にわかれます。<br />
        1つは基準日を持つデータ(①)、もう1つは基準日を持たないデータ(②)です。<br />
        判断基準は以下のとおりです。<br />
        ①
        上記の表の"基準日"列に基準日があり、基準日を持つデータ<br />
        ②
        上記の表の"基準日"列に基準日がなく、基準日を持たないデータ<br />
      </p>
    </div>
    <p class="item subtitle">取得できるデータフォーマット</p>
    <p class="item">
      上記のデータ一覧に記載のあるデータをAPI経由ではNGSIv2に準拠したフォーマットで取得することが可能です。<br />
      NGSIv2に準拠したエンティティの定義は、基準日を持つデータと基準日を持たないデータごとに異なります。<br />
      各エンティティの定義は以下の通りとなります。
    </p>
    <div class="json">
      <b>エンティティの定義（基準日を持つデータ）</b>
      <p>APIレスポンスとして以下の形式でエンティティをJSON形式で返却します。</p>
      <pre>
[
    {
        "id": "urn:ngsi-ld:EDDE04000-2002-02-01:1",
        "type": "EDDE04000-2002-02-01",
        "acquisition-date": {
            "type": "DateTime",
            "value": "2002-02-01T00:00:00.000Z",
            "metadata": {}
        },
        "clothing_and_footwear_index": {
            "type": "numeric",
            "value": 93.3,
            "metadata": {
                "base_col_name": {
                    "type": "text",
                    "value": "被服及び履物_指数"
                }
            }
        },
        "clothing_and_footwear_weights": {
            "type": "numeric",
            "value": 626,
            "metadata": {
                "base_col_name": {
                    "type": "text",
                    "value": "被服及び履物_ウエイト"
                }
            }
        }
        ・・・
    },
    ・・・
]
    </pre
      >
    </div>
    <div class="json">
      <b>エンティティの各要素について（基準日を持つデータ）</b>
      <p>エンティティに含まれる各要素については以下の通りです。</p>
      <div class="resEl" v-for="item in responseEl" :key="item.title">
        <p class="resElTtl">{{ item.title }}</p>
        <p class="resElExp" v-html="item.explane"></p>
      </div>
    </div>
    <div class="json">
      <b>エンティティの定義（基準日を持たないデータ）</b>
      <p>APIレスポンスとして以下の形式でエンティティをJSON形式で返却します。</p>
      <pre>
[
    {
        "id": "urn:ngsi-ld:EDDE04599:1",
        "type": "EDDE04599",
        "composite_index": {
            "type": "numeric",
            "value": 30.2,
            "metadata": {
                "base_col_name": {
                    "type": "text",
                    "value": "総合_指数"
                }
            }
        },
        "composite_index_excluding_fresh_food": {
            "type": "numeric",
            "value": 30.7,
            "metadata": {
                "base_col_name": {
                    "type": "text",
                    "value": "生鮮食品を除く総合_指数"
                }
            }
        },
        ・・・
    },
    ・・・
]
    </pre
      >
    </div>
    <div class="json">
      <b>エンティティの各要素について（基準日を持たないデータ）</b>
      <p>エンティティに含まれる各要素については以下の通りです。</p>
      <div class="resEl" v-for="item in responseElNonDate" :key="item.title">
        <p class="resElTtl">{{ item.title }}</p>
        <p class="resElExp" v-html="item.explane"></p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  data() {
    return {
      errorFlag: false,
      categorySelected: true,
      show: false,
      pages: 0,
      page: 1,
      perPage: 10,
      items: 0,
      datas: [],
      selected_data: [],
      largeCategory: [],
      smc: [],
      selectedCategory: "",
      selectedSmc: "",
      responseEl: [
        {
          title: "全体",
          explane:
            "クエリ条件に合致したエンティティが配列内オブジェクトの形式で返却されます。",
        },
        {
          title: "id",
          explane: `エンティティを特定するためにエンティティごとに一意な値が入ります。<br>
          基準日を持つデータについては、<br>
          「 urn:ngsi-ld:データ番号-基準日:元データの行数 」となります。`,
        },
        {
          title: "type",
          explane: `エンティティのタイプを示します。<br>
          基準日を持つデータについては、<br>
          「 データ番号-基準日 」となります。`,
        },
        {
          title: "acquisition-date",
          explane: `基準日、つまり、いつ時点での情報なのかを示します。<br>
          valueキーに基準日を示すタイムスタンプが格納されています。`,
        },
        {
          title:
            "属性（上記の例ではclothing_and_footwear_indexやclothing_and_footwear_weights）",
          explane: "具体的な情報の内容を示します。",
        },
        {
          title: "属性 > value",
          explane: "各属性の値",
        },
        {
          title: "属性 > metadata > base_col_name",
          explane:
            "データカタログサイト上で掲載されている元データにおける日本語の列名",
        },
        {
          title: "解釈の例",
          explane: `上記の例において以下のように解釈をすることが可能です。<br>
          type = EDDE04000-2002-02-01<br>
          => このエンティティはデータ番号EDDE04000（消費者物価指数（10大費目））に関するデータを示しており、2002年2月1日時点のデータである。<br>
          clothing_and_footwear_index > metadata > base_col_name > value = 被服及び履物_指数<br>
          clothing_and_footwear_index > value = 93.3<br>
          => 被服及び履物の消費者物価指数が93.3である。`,
        },
      ],
      responseElNonDate: [
        {
          title: "全体",
          explane:
            "クエリ条件に合致したエンティティが配列内オブジェクトの形式で返却されます。",
        },
        {
          title: "id",
          explane: `エンティティを特定するためにエンティティごとに一意な値が入ります。<br>
          基準日を持たないデータについては、<br>
          「 urn:ngsi-ld:データ番号:元データの行数 」となります。`,
        },
        {
          title: "type",
          explane: `エンティティのタイプを示します。<br>
          基準日を持たないデータについては、データ番号となります。`,
        },
        {
          title:
            "属性（上記の例ではcomposite_indexやcomposite_index_excluding_fresh_food）",
          explane: "具体的な情報の内容を示します。",
        },
        {
          title: "属性 > value",
          explane: "各属性の値",
        },
        {
          title: "属性 > metadata > base_col_name",
          explane:
            "データカタログサイト上で掲載されている元データにおける日本語の列名",
        },
        {
          title: "解釈の例",
          explane: `上記の例において以下のように解釈をすることが可能です。<br>
          type = EDDE04599<br>
          => このエンティティはデータ番号EDDE04599（消費者物価指数（10大費目））に関するデータである。<br>
          composite_index > metadata > base_col_name > value = 総合_指数<br>
          composite_index > value = 30.2<br>
          => 総合の消費者物価指数が30.2である。`,
        },
      ],
    };
  },
  watch: {
    page() {
      let tmpArr = [];
      for (let i = 0; i < this.items; i += this.perPage)
        tmpArr.push(this.datas.slice(i, i + this.perPage));
      this.selected_data = tmpArr[this.page - 1];
    },
    selectedCategory() {
      this.selectedSmc = "";
      if (this.selectedCategory == "") {
        this.categorySelected = true;
      } else {
        let tmpArr = [];
        for (let i = 0; i < this.items; i++) {
          if (this.datas[i].largeCategory == this.selectedCategory) {
            tmpArr.push(this.datas[i].smc);
          }
        }
        this.smc = Array.from(new Set(tmpArr));
        this.categorySelected = false;
      }
    },
  },
  methods: {
    clear() {
      this.page = 1;
      this.selectedCategory = "";
      this.selectedSmc = "";
      this.datas = [];
      this.selected_data = [];
      axios
        .get("https://api.dataplatform-yamanashi.jp/orion-data", {
          params: {
            table_name: "dataToBeRegistered",
            lc: this.selectedCategory,
            sm: this.selectedSmc,
          },
        })
        .then((response) => {
          this.datas = response.data;
          this.items = this.datas.length;
          this.pages = Math.ceil(this.items / this.perPage);
          let tmpArr = [];
          for (let i = 0; i < this.items; i += this.perPage) {
            tmpArr.push(this.datas.slice(i, i + this.perPage));
          }
          this.selected_data = tmpArr[this.page - 1];

          tmpArr = [];
          for (let i = 0; i < this.items; i++) {
            tmpArr.push(this.datas[i].largeCategory);
          }
          this.largeCategory = Array.from(new Set(tmpArr));
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
    search() {
      this.page = 1;
      this.datas = [];
      this.selected_data = [];
      axios
        .get("https://api.dataplatform-yamanashi.jp/orion-data", {
          params: {
            table_name: "dataToBeRegistered",
            lc: this.selectedCategory,
            sm: this.selectedSmc,
          },
        })
        .then((response) => {
          this.datas = response.data;
          console.log(this.datas);
          this.items = this.datas.length;
          this.pages = Math.ceil(this.items / this.perPage);
          let tmpArr = [];
          for (let i = 0; i < this.items; i += this.perPage) {
            tmpArr.push(this.datas.slice(i, i + this.perPage));
          }
          this.selected_data = tmpArr[this.page - 1];

          tmpArr = [];
          for (let i = 0; i < this.items; i++) {
            tmpArr.push(this.datas[i].largeCategory);
          }
          this.largeCategory = Array.from(new Set(tmpArr));
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
  },
  mounted() {
    axios
      .get("https://api.dataplatform-yamanashi.jp/orion-data", {
        params: {
          table_name: "dataToBeRegistered",
          lc: this.selectedCategory,
          sm: this.selectedSmc,
        },
      })
      .then((response) => {
        this.datas = response.data;
        this.items = this.datas.length;
        this.pages = Math.ceil(this.items / this.perPage);
        let tmpArr = [];
        for (let i = 0; i < this.items; i += this.perPage) {
          tmpArr.push(this.datas.slice(i, i + this.perPage));
        }
        this.selected_data = tmpArr[this.page - 1];

        tmpArr = [];
        for (let i = 0; i < this.items; i++) {
          tmpArr.push(this.datas[i].largeCategory);
        }
        this.largeCategory = Array.from(new Set(tmpArr));
      })
      .catch((error) => {
        console.log(error);
        this.errorFlag = true;
      });
  },
  components: {
    Loading,
  },
  computed: {
    lastUpdate() {
      var now = new Date();
      var Year = now.getFullYear();
      var Month = now.getMonth() + 1;
      var day = now.getDate();
      var Hour = now.getHours();
      var Min = now.getMinutes();
      if (15 > Min && Min > 0) {
        Min = 0;
      } else if (30 > Min && Min > 15) {
        Min = 15;
      } else if (45 > Min && Min > 30) {
        Min = 30;
      } else {
        Min = 45;
      }
      Year = Year.toString().padStart(2, "0");
      Month = Month.toString().padStart(2, "0");
      day = day.toString().padStart(2, "0");
      Hour = Hour.toString().padStart(2, "0");
      Min = Min.toString().padStart(2, "0");
      return Year + "/" + Month + "/" + day + " " + Hour + ":" + Min;
    },
  },
};
</script>

<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.item {
  font-size: 1.4vw;
}

.subtitle {
  font-weight: 700;
}

.table {
  position: relative;
  margin-bottom: 72px;
}

.dataCounter {
  font-size: 1.4vw;
  font-weight: 500;
  margin: 2vw 0 0.5vw 0;
}

.dataCounter span {
  font-size: 2vw;
  padding: 0 1.6vw;
  color: #072a40;
  font-weight: 700;
}

.updateTime {
  font-size: 1vw;
  margin-bottom: 0.8vw;
}

.tableWrap {
  max-width: 56vw;
  overflow: auto;
}

.dataTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 1vw;
}

.dataTable th,
.dataTable td {
  border: 2px solid #eee;
  padding: 0.6vw 1.5vw;
  white-space: nowrap;
}

.nowLoading {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
}

.fillterSpase {
  width: 64%;
  margin-bottom: 24px;
}

.category {
  padding: 1vw;
  margin-bottom: 3vw;
}

.chips {
  padding: 2vw;
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5vw;
  row-gap: 1.5vw;
}

.card {
  margin-top: 36px;
  padding: 1vw;
}

.fillter {
  display: grid;
  padding: 2vw;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 0.5fr;
  grid-column-gap: 20px;
}
.cardTitle {
  display: grid;
  grid-template-columns: 30px auto auto 30px;
  grid-template-rows: auto;
  justify-items: start;
  align-items: center;
  grid-template-areas: "filterIcon filterTitle . arrowIcon";
  font-size: 1.2vw;
  cursor: pointer;
}

.filterIcon {
  grid-area: filterIcon;
}

.filterTitle {
  grid-area: filterTitle;
  font-size: 1vw;
  font-weight: 500;
}

.arrowIcon {
  grid-area: arrowIcon;
}
.expand {
  padding: 28px 0;
}

.json {
  font-size: 1.2vw;
  margin-top: 48px;
}

.resEl {
  margin-top: 36px;
  padding-left: 2vw;
}

.resElTtl {
  font-weight: 500;
}

pre {
  white-space: pre-wrap;
  word-break: break-all;
  margin-top: 36px;
  padding-left: 2vw;
}
</style>
